<template>
  <div class="subtitle">
    <span>
      <slot />
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import './AppSubtitle.scss';
</style>
